var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "conteudo-modal" }, [
    _vm._m(0),
    _vm._v(" "),
    _c("div", { staticClass: "informacao" }, [
      _c("div", { staticClass: "passou box" }, [
        _c("p", { staticClass: "texto-white" }, [
          _vm._v(_vm._s(this.setorOuStatus + " pelo qual o processo já passou"))
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "pendente box" }, [
        _c("p", { staticClass: "texto-black" }, [
          _vm._v(
            _vm._s(
              this.setorOuStatus + " pelo qual o processo ainda não passou"
            )
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "atual box" }, [
        _c("p", { staticClass: "texto-white" }, [
          _vm._v(_vm._s(this.setorOuStatus + " atua") + "l")
        ])
      ])
    ]),
    _vm._v(" "),
    _vm.isMicro
      ? _c("div", { staticClass: "voltar" }, [
          _c(
            "span",
            {
              staticClass: "btn-voltar",
              attrs: {
                type: "button",
                "aria-label": "Voltar para o fluxo macro"
              },
              on: { click: _vm.reloadMacro }
            },
            [
              _c(
                "svg",
                {
                  attrs: {
                    width: "22",
                    height: "22",
                    viewBox: "0 0 24 24",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg"
                  }
                },
                [
                  _c("path", {
                    attrs: {
                      d: "M10 6L4 12L10 18",
                      stroke: "currentColor",
                      "stroke-width": "2.5",
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round"
                    }
                  }),
                  _vm._v(" "),
                  _c("path", {
                    attrs: {
                      d: "M4 12H20",
                      stroke: "currentColor",
                      "stroke-width": "2.5",
                      "stroke-linecap": "round"
                    }
                  })
                ]
              )
            ]
          )
        ])
      : _vm._e()
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { attrs: { id: "app-bpmn" } }, [
      _c("div", { attrs: { id: "bpmn-container" } })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2c417162", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2c417162","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AppBpmnViewer.vue
// module id = null
// module chunks = 